module.exports = __webpack_public_path__ + "static/media/user.c2f5618b.svg";